module.exports = __webpack_public_path__ + "78b4c41ef292f4dc2a52d512cbd44fbf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/phone.svg
// module id = 772
// module chunks = 0